<ng-container>
  <svg [attr.width]="width" [attr.height]="height" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.5451 20.3077C14.5647 20.3077 15.3912 21.1342 15.3912 22.1538C15.3912 23.1734 14.5647 24 13.5451 24H6.17397C5.15437 24 4.32782 23.1734 4.32782 22.1538C4.32782 21.1342 5.15437 20.3077 6.17397 20.3077H13.5451ZM9.85953 0C14.9513 0 19.079 4.13276 19.079 9.23077C19.079 14.3288 14.9513 18.4615 9.85953 18.4615C4.76773 18.4615 0.640015 14.3288 0.640015 9.23077C0.640015 4.13276 4.76773 0 9.85953 0ZM9.85953 3.69231C6.80445 3.69231 4.32782 6.17196 4.32782 9.23077C4.32782 12.2896 6.80445 14.7692 9.85953 14.7692C12.9146 14.7692 15.3912 12.2896 15.3912 9.23077C15.3912 6.17196 12.9146 3.69231 9.85953 3.69231Z"
      [attr.fill]="color" />
  </svg>
</ng-container>
